/*
 * @Author: ç¯çç§æ(Lucas Huang)
 * @Date: 2019-08-15 15:24:24
 * @LastEditors: ç¯çç§æ(Lucas Huang)
 * @LastEditTime: 2019-11-30 14:01:34
 * @QQ: 1055818239
 * @Version: v0.0.1
 */
import { Subscription, Observable, of, Subject } from 'rxjs';
import {
    Component, Input, Output, EventEmitter, TemplateRef,
    ViewChild, Injector, forwardRef, OnInit, ElementRef, ChangeDetectorRef,
    AfterViewChecked, HostBinding, NgZone, OnDestroy
} from '@angular/core';
import {
    NG_VALUE_ACCESSOR,
    ControlValueAccessor,
    NgControl
} from '@angular/forms';

import { DialogComponent } from '@farris/ui-dialog';
import { IResizeEvent } from '@farris/ui-draggable';

import { PickingResult, PickedResult } from './lookup-grid-options';

export const LOOKUPINPUT_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => LookupComponent),
    multi: true
};

@Component({
    selector: 'farris-lookup',
    template: `
        <div
            class="lookupbox input-group"
            [ngClass]="{
                'f-state-disabled': disabled,
                'f-state-readonly': readonly,
                'f-state-editable': !editable
            }"
        >
            <input
                class="form-control"
                [value]="displayText"
                [disabled]="disabled"
                [readonly]="!editable || readonly"
            />
            <div class="input-group-append">
                <span class="f-select input-group-text" (click)="showDialog()">
                    <i class="f-icon f-icon-lookup"></i>
                </span>
            </div>
        </div>
        <farris-dialog
            #dialog
            *ngIf="isShow"
            [title]="title"
            [beforeOpen]="beforeOpen"
            [beforeClose]="beforeClose"
            [width]="dialogWidth"
            [height]="dialogHeight"
            [showButtons]="showButtons"
            [showMaxButton]="showMaxButton"
            [buttons]="buttonsRef || defaultButtonRef"
            [buttonAlign]="buttonAlign"
            (maxed)="onMaxDialog($event)"
            (resized)="onResized($event)"
            (resizing)="onResizing($event)"
        >
            <ng-content></ng-content>

            <ng-template #defaultButtonRef>
                <div style="width: 100%;">
                    <button
                        class="btn btn-secondary btn-lg"
                        (click)="closeDialog()"
                    >
                        Cancel
                    </button>
                    <button class="btn btn-primary btn-lg">Ok</button>
                </div>
            </ng-template>
        </farris-dialog>
    `,
    styles: [
        `
            .input-group {
                flex-wrap: nowrap;
            }
            :host-context(.ng-invalid) .form-control {
                border-color: #ff0303;
            }
        `
    ],
    providers: [LOOKUPINPUT_VALUE_ACCESSOR]
})
export class LookupComponent
    implements OnInit, ControlValueAccessor, AfterViewChecked, OnDestroy {
    @HostBinding('class') hostCls = 'f-cmp-inputgroup';

    /** çªå£å®½åº¦ */
    @Input() dialogWidth: number;
    /** çªå£é«åº¦ */
    @Input() dialogHeight: number;
    /** çªå£æ é¢ãé»è®¤å¼ï¼æ­¤å¤æ¾ç¤ºå¸®å©æ é¢ */
    @Input() title = '';
    /** æé®å¯¹é½æ¹å¼ */
    @Input() buttonAlign = 'right';
    /** æé®æ¨¡æ¿ */
    @Input() buttonsRef: TemplateRef<any>;
    /** æ¯å¦æ¾ç¤ºæé® */
    @Input() showButtons = true;
    /** æ¾ç¤ºå³é­æé® */
    @Input() showCloseButton = true;
    /** æ¾ç¤ºæå¤§åæé® */
    @Input() showMaxButton = true;
    /** åè®¸ææ½å°ºå¯¸ */
    @Input() resizable = true;
    /** åè®¸æå¨çªå£ */
    @Input() draggable = true;
    /** ç¦ç¨ */
    @Input() disabled = false;
    /** åè®¸ç¼è¾ææ¬æ¡ */
    @Input() editable = true;
    /** åªè¯» */
    @Input() readonly = false;
    /** å­æ®µæ å°, { å¸®å©æ°æ®å­æ®µï¼è¡¨åå­æ®µ } */
    @Input() mapFields: { [sourceField: string]: string };
    /** å¼å­æ®µ */
    @Input() valueField: string;
    /** ææ¬å­æ®µ */
    @Input() textField: string;
    @Input() displayText = '';

    /** è¿è¡æ¶ä¸ä¸æèªå®ä¹å¯¹è±¡ */
    @Input() context: any;

    /** çªå£æå¼åäºä»¶ */
    @Input() beforeOpen: () => Observable<boolean>;
    /** çªå£å³é­åäºä»¶ */
    @Input() beforeClose: () => Observable<boolean>;
    /** å¸®å©åäºä»¶ */
    @Input() dictPicking: (emptyObj?: {}) => Observable<PickingResult>;
    dictPickingSubscription: Subscription;
    /** å¸®å©åäºä»¶ */
    @Input() dictPicked: (rowData: any) => Observable<PickedResult>;
    dictPickedSubscription: Subscription;

    /** çªå£æå¼å */
    @Output() dialogOpened = new EventEmitter();
    /** çªå£å³é­å */
    @Output() dialogClosed = new EventEmitter();
    /** çªå£æå¤§å */
    @Output() dialogMaxed = new EventEmitter();
    /** ææ½æ¹åçªå£å°ºå¯¸è¿è¡æ¶ */
    @Output() resizing = new EventEmitter();
    /** ææ½æ¹åçªå£å°ºå¯¸ç»æ */
    @Output() resized = new EventEmitter();
    /** å¸®å©çªå£é»è®¤å°ºå¯¸ */
    private defaultDialogSize = { width: 550, height: 570 };

    dialogCreated = new Subject<DialogComponent>();
    dialogCreatedSubscription: Subscription;
    dialog: DialogComponent;
    @ViewChild('dialog') set content(content: DialogComponent) {
        if (this.dialog !== content) {
            this.dialog = content;
            if (content) {
                this.dialogCreated.next(this.dialog);
            }
        }
    }

    private _isShow = false;
    get isShow() {
        return this._isShow;
    }
    set isShow(val) {
        this._isShow = val;
        if (!this.changeDetector['destroyed']) {
            this.changeDetector.detectChanges();
        }
    }

    ngControl: any;

    displayValue = '';
    originalText = '';

    get invalid() {
        return this.ngControl.valid;
    }

    private ngZone: NgZone;

    onModelChange = (obj: any) => { };
    onModelTouched = (val: any) => { };
    constructor(
        public injector: Injector,
        public el: ElementRef,
        public changeDetector?: ChangeDetectorRef
    ) {
        this.ngZone = this.injector.get(NgZone);
        // if (!this.personalConfigService) {
        //     const idServ = this.injector.get(IdService);
        //     this.personalConfigService = new PersonalConfigService(idServ);
        // }
    }

    ngOnInit(): void {
        this.initEvents();
        this.ngControl = this.injector.get(NgControl, null);
    }

    ngOnDestroy() {
        this.lookupUnsubscribe();
    }

    ngAfterViewChecked() {
        if (this.dialog) {
            this.dialog.closed.subscribe(() => {
                this.isShow = false;
                this.dialog = null;
            });
        }
    }

    initEvents() {
        if (!this.dictPicking) {
            this.dictPicking = () => of({ showDialog: true });
        }
        if (!this.dictPicked) {
            this.dictPicked = () => of({ closeDialog: true });
        }
        if (!this.beforeOpen) {
            this.beforeOpen = () => of(true);
        }
        if (!this.beforeClose) {
            this.beforeClose = () => of(true);
        }

        if (!this.dialogHeight) {
            this.dialogHeight = this.defaultDialogSize.height;
        }

        if (!this.dialogWidth) {
            this.dialogWidth = this.defaultDialogSize.width;
        }
    }

    showDialog(): any {
        if (this.disabled || this.readonly) {
            return false;
        }
        this.dictPicking().subscribe((val: PickingResult) => {
            if (val.showDialog === false) {
                return;
            }

            this.isShow = true;
            // this.changeDetector.detectChanges();
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() => this.dialog.show());
            });
        });

        return false;
    }

    closeDialog() {
        this.isShow = false;
        if (this.dialog) {
            this.dialog.close();
        }
    }


    private lookupUnsubscribe() {
        if (this.dictPickedSubscription) {
            this.dictPickedSubscription.unsubscribe();
        }
        if (this.dictPickingSubscription) {
            this.dictPickingSubscription.unsubscribe();
        }
        if (this.dialogCreatedSubscription) {
            this.dialogCreatedSubscription.unsubscribe();
        }
    }

    onResizing(pos: IResizeEvent) {
        this.resizing.emit(pos.size);
    }
    onResized(pos: IResizeEvent) {
        this.resized.emit(pos.size);
    }
    onMaxDialog(pos: IResizeEvent) {
        this.dialogMaxed.emit(pos.size);
    }

    writeValue(obj: any): void {
        if (obj) {
            this.displayText = obj;
            this.displayValue = obj;
            this.originalText = this.displayText;
        } else {
            this.displayText = '';
            this.displayValue = '';
            this.originalText = '';
        }
    }
    registerOnChange(fn: any): void {
        this.onModelChange = fn;
    }
    registerOnTouched(fn: any): void {
        this.onModelTouched = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
